const quizData = [
  {
    id: 1,
    prompt:
      "SPIRITUALITY: Where are you right now in your faith or spiritual journey? (Click all that apply)",
    options: [
      "🔸 I believe in God (or a Higher Power) guiding my life 💫",
      "🔸 I’m searching for truth and deeper meaning 🫥",
      "🔸 I feel disillusioned or confused about religion or faith ⚡️",
      "🔸 I don’t really believe in God, heaven, or hell 🫧",
      "🔸 I’ve felt judged or misunderstood by religious people 😕",
      "🔸 I feel lost and unsure what to believe anymore 🤷‍♀️ 🤷🏼‍♂️",
      "🔸 None of these above describe me at all 🙂‍↔️",
    ],
  },
  {
    id: 2,
    prompt:
      "EMOTIONALLY: How have you been feeling lately — honestly? (Click all that apply)",
    options: [
      "😔 I feel lost or unsure where my life is going",
      "💭 My life feels empty or disappointing 😑",
      "🏃 I keep trying to escape my reality",
      "💔 I struggle to understand or manage my emotions",
      "🌊 I often feel overwhelmed or mentally drained 😩",
      "🕳️ Happiness feels like something I can’t quite reach",
      "🌞 None of these — I feel grounded and at peace most of the time ✌🏼🧘‍♀️",
    ],
  },
  {
    id: 3,
    prompt:
      "CLARITY & DIRECTION: How clear do you feel about your life’s purpose? (Click all that apply)",
    options: [
      "🧭 I’m seeking more wisdom, discipline, and clarity 🕵️‍♀️",
      "💪 I struggle with confidence and self-worth",
      "🔥 I’m trying to rediscover my boldness and inner drive",
      "🕰️ I’ve had some success but something still feels missing",
      "🏔️ I want to push past fear and finally move forward",
      "🧩 I feel like something important is missing in my life",
      "✅ None apply — I feel fulfilled and aligned with my goals 🎯",
    ],
  },
  {
    id: 4,
    prompt:
      "ENDURANCE: How do you feel about your motivation and consistency? (Click all that apply)",
    options: [
      "⚙️ I make progress but struggle to stay consistent 🗺️",
      "🧱 I often lose strength or direction",
      "😨 I feel stuck or afraid to try new things",
      "🦁 I want to build courage and confidence in myself 💪🏻",
      "🪞 I want to understand myself more deeply",
      "🤝 I feel called to help others with what I’ve learned 📣",
      "🌟 None apply — I’m steady, focused, and living with purpose",
    ],
  },
  {
    id: 5,
    prompt:
      "RELATIONALLY: What best describes your relationships and sense of connection? (Click all that apply)",
    options: [
      "💔 I struggle to maintain healthy relationships",
      "🌫️ I often feel disconnected or alone",
      "🙃 I give too much trying to make others happy 🏃‍♂️",
      "👨‍👩‍👧 I grew up with an absent or inconsistent parent figure",
      "💣 My love life feels chaotic or confusing 😵‍💫",
      "👀 I often feel unseen or unappreciated ✋",
      "💞 None apply — I feel loved, connected, and supported",
    ],
  },
  {
    id: 6,
    prompt:
      "RELEVANCE: What best describes your sense of fulfillment or meaning in life? (Click all that apply)",
    options: [
      "🚀 I want to become the best version of myself 💎",
      "🎯 I’m chasing my destiny and deeper fulfillment",
      "🌌 I want to understand the true meaning of life",
      "❤️ I want to live a life that truly matters",
      "🤔 Sometimes I think, there’s got to be more than this",
      "😌 I feel content and grateful most of the time 🙏🏻",
      "💯% None apply — I’m completely at peace and satisfied 😎👌🏼",
    ],
  },
];

export default quizData;
